<template>
  <sa-page-layout :btnSaveVisible="true" :data="jsonData" :btnAnnullaVisible="true" :showModalLoading="showModalLoading" :linkback="linkback" :pathResource="pathResource" class="sa-no-space">
    <template slot="toolbar">
      <b-button v-if="id !== '-1'" variant="outline-success btn-toolbar sa-margin-left float-sm-left" v-b-modal.mdlAllegati>
        <b-icon icon="file-earmark-plus" aria-hidden="true"></b-icon>
        Allegati
      </b-button>
    </template>
    <template slot="table-body">
      <b-tabs content-class="mt-3" ref="tabs" class="sa-tab" style="height: 100%" fill>
        <b-tab title="Scheda Valutazione Esigenze Immediate" active>
          <scheda-valutazione-esigenze-immediate-edit-component @update="onUpdateJsonData"></scheda-valutazione-esigenze-immediate-edit-component>
        </b-tab>
        <b-tab title="Allegati">
          <allegato-model-component :idRisorsa="id" @updateFiles="onUpdateFile()" :jsonData="jsonData" tipoDocumento="SCHEDAVALUTAZIONEESIGENZEIMMEDIATE"></allegato-model-component>
        </b-tab>
      </b-tabs>
    </template>
  </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import AllegatoModelComponent from "../../utility/components/AllegatoModelComponent.vue";
import SchedaValutazioneEsigenzeImmediateEditComponent from "../components/SchedaValutazioneEsigenzeImmediateEditComponent.vue";
export default {
  components: { SaPageLayout, SchedaValutazioneEsigenzeImmediateEditComponent, AllegatoModelComponent },
  data() {
    return {
      id: "-1",
      pathResource: "/schedavalutazioneesigenzeimmediate",
      linkback: "/schedavalutazioneesigenzeimmediate",
      showModalLoading: false,
      jsonData: {},
    };
  },
  mounted() {
    let me = this;
    me.id = this.$route.params.id;
  },
  methods: {
    onUpdateJsonData(data) {
      // console.log("OK");
      let me = this;
      me.jsonData = data;
    },
  },
};
</script>

<style></style>
